import { GET_LINKS_TRACKING_SUCCESS } from './constants';

const initialState = {};

/**
 *
 * @param state
 * @param action
 * @returns {{}&{linksTracking: *}}
 */
const statisticsQuestionsReducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case GET_LINKS_TRACKING_SUCCESS: {
            return {
                ...state,
                linksTracking: action.statistics
            };
        }
        default: {
            return state;
        }
    }
};

export { statisticsQuestionsReducer as linksTrackingStatistics };